// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
/*eslint-disable*/
import Vue from 'vue'
import App from './App'
import router from './router'
import FastClick from 'fastclick'
import '../static/js/flexible.js'
// import VueAMap from 'vue-amap';
import utils from '@/util/default';
import { POST, GET } from './http/http';
import { Toast, NoticeBar, Swipe, SwipeItem, Icon, Lazyload, Picker, Popup, NavBar, Sidebar, SidebarItem, Tab, Tabs, Loading, Overlay, Notify, Search } from 'vant'
import 'vant/lib/index.css'
Vue.use(Toast).use(NoticeBar).use(Swipe).use(SwipeItem).use(Icon).use(Lazyload).use(Picker).use(Popup).use(NavBar).use(Sidebar).use(SidebarItem).use(Tab).use(Tabs).use(Loading).use(Overlay)
  .use(Notify).use(Search);

Vue.prototype.$utils = utils
// Vue.use(VueAMap);
Vue.prototype.$get = GET;
Vue.prototype.$post = POST;

// VueAMap.initAMapApiLoader({
//   key: '0250860ccb5953fa5d655e8acf40ebb7',
//   plugin: [
//     "AMap.Autocomplete", //输入提示插件
//     "AMap.PlaceSearch", //POI搜索插件
//     "AMap.Scale", //右下角缩略图插件 比例尺
//     "AMap.OverView", //地图鹰眼插件
//     "AMap.ToolBar", //地图工具条
//     "AMap.MapType", //类别切换控件，实现默认图层与卫星图、实施交通图层之间切换的控制
//     "AMap.PolyEditor", //编辑 折线多，边形
//     "AMap.CircleEditor", //圆形编辑器插件
//     "AMap.Geolocation", //定位控件，用来获取和展示用户主机所在的经纬度位置
//   ],
//   v: '1.4.4'
// });

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title// 显示每个页面在router中设置的标题
  }
  next()
})

Vue.config.productionTip = false
FastClick.attach(document.body)

new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js